var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import LazyLoad from 'react-lazyload';
var CardImage = (function (_super) {
    __extends(CardImage, _super);
    function CardImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardImage.prototype.getFinalSize = function () {
        var _a = this.props.templateData, width = _a.width, height = _a.height;
        var maxWidth = 200;
        var minWidth = 50;
        var finalSize = {
            width: width,
            height: height
        };
        if (+width > maxWidth) {
            finalSize.width = maxWidth;
            finalSize.height = Math.round(maxWidth * height / width);
        }
        else if (!width) {
            finalSize.width = minWidth;
        }
        return finalSize;
    };
    CardImage.prototype.render = function () {
        var _this = this;
        var templateData = this.props.templateData;
        var finalSize = this.getFinalSize();
        return (React.createElement(LazyLoad, { overflow: true, once: true, height: finalSize.height, ref: function (ref) { return _this.lazy = ref; } },
            React.createElement("video", { className: "video", src: templateData.videoUrl, poster: templateData.imgUrl, muted: true, controls: true })));
    };
    return CardImage;
}(React.Component));
export default CardImage;

//# sourceMappingURL=index.js.map
